import {useState, type Dispatch, type SetStateAction} from "react";

/** Single responsibility: manage the loading indicator and the side panel open/close state. */
const useConstructionCalculationsUIStateHook = (): {
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  sideMenuOpen: boolean;
  handleSideMenuOpenState: () => void;
} => {
  const [loading, setLoading] = useState<boolean>(true);
  const [sideMenuOpen, setSideMenuOpen] = useState<boolean>(false);

  const handleSideMenuOpenState = (): void => {
    setSideMenuOpen(prev => !prev);
  };

  return {loading, setLoading, sideMenuOpen, handleSideMenuOpenState};
};

export default useConstructionCalculationsUIStateHook;
